(function () {
    'use strict';

    var serviceId = 'searchEngine';

    angular.module('app.common')
        .factory(serviceId, ['$q', 'yandexGeocode', 'Uavt', '$window', 'parcelClientService', 'urlSearchApi', 'searchParserService', searchEngine]);

    function searchEngine($q, yandexGeocode, Uavt, $window, parcelClientService, urlSearchApi, searchParserService) {
        var obj = {
            searchUrl: searchUrl,
            searchTitleNo: searchTitleNo,
            searchCoordinate: searchCoordinate,
            searchAddressCode: searchAddressCode,
            searchParcel: searchParcel,
            searchLocation: searchLocation,
            cleanRecords: cleanRecords
        };

        return obj;

        function cleanRecords() {
            $window.mallId = null;
            $window.endeksaId = null;
            $window.agentId = null;
            $window.opportId = null;
            $window.regionId = null;
            $window.projectId = null;
            $window.rememberProperty = null;
            $window.selectedLocation = null;
            $window.gatheredLocation = null;
            $window.parcelRecord = null;
        }


        function searchUrl(url) {
            var defer = $q.defer();
            window.dataLayer.push({
                event: "search",
                search_term: 'url',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            var urlSearch = urlSearchApi.get({ ListingURL: url });
            urlSearch.$promise.then(function (res) {
                if (res.Lat) {
                    $window.rememberProperty = res;
                    $window.selectedLocation = res.Lon + ' ' + res.Lat;
                    $window.gatheredLocation = $window.selectedLocation;
                    var location = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
                    defer.resolve(location);
                } else {
                    defer.reject();
                }
            }, function (res) {
                if (res && res.data && res.data.Message)
                    defer.reject(res.data.Message);
                else
                    defer.reject();
            });
            return defer.promise;
        }

        function searchTitleNo(zemin) {
            var defer = $q.defer();
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: 'titledeed'
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'titledeed',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            parcelClientService.getParcelInfoByPropertyId(zemin).then(
                function (result) {
                    $window.selectedLocation = result.data.center[0] + ' ' + result.data.center[1];
                    $window.gatheredLocation = $window.selectedLocation;
                    var location = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
                    defer.resolve(location);
                },
                function () {
                    defer.reject();
                }
            );
            return defer.promise;
        }

        function searchCoordinate(coordinates) {
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: 'coordinate'
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'coordinate',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            var coords = coordinates.replaceAllString('#', '').replaceAllString('/ ', ' ').replaceAllString('/', ' ').replaceAllString(', ', ' ').replaceAllString(',', '').replaceAllString(';', ' ').replaceAllString(':', ' ').replace('parselsorgu.tkgm.gov.tr', '').replace('https', '').trim();
            var center = coords.split(' ');
            $window.selectedLocation = center[1] + ' ' + center[0];
            $window.gatheredLocation = $window.selectedLocation;
            var location = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
            return location;
        }
        function searchAddressCode(id) {
            var defer = $q.defer();
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: 'uavt'
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'uavt',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            var uavt = Uavt.get({ id: id });
            uavt.$promise.then(function (res) {
                if (res.Location.Address) {
                    var address = res.Location.Address.replace(' TÜRKİYE', '').replace(' TURKEY', '');
                    yandexGeocode.geocodeAddress(address).then(function (location) {
                        $window.selectedLocation = location.lng() + ' ' + location.lat();
                        $window.gatheredLocation = $window.selectedLocation;;
                        var locationr = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
                        defer.resolve(locationr);
                    }, function () {
                        defer.reject();
                    });
                } else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            });

            return defer.promise;
        }

        function searchParcel(mahalle, ada, parsel) {
            var defer = $q.defer();
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: 'parcel'
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'parcel',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            parcelClientService.getParcelByValues(mahalle, ada, parsel).then(function (result) {
                try {
                    result.data.center = searchParserService.centerInPoly(result.data.center)
                    $window.selectedLocation = result.data.center[0] + ' ' + result.data.center[1];
                    $window.gatheredLocation = $window.selectedLocation;
                    var location = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
                    defer.resolve(location);
                } catch (err) {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            });
            return defer.promise;
        }

        function searchLocation() {
            var defer = $q.defer();
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: "location"
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'location',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            navigator.geolocation.getCurrentPosition(function (position) {
                console.log(position);
                if (position) {
                    var location = position.coords.latitude.toString().replace('.', ',') + ";" + position.coords.longitude.toString().replace('.', ',');
                    $window.selectedLocation = position.coords.longitude + ' ' + position.coords.latitude;
                    $window.gatheredLocation = $window.selectedLocation;
                    defer.resolve(location);
                }
                else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            }, {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            });
            return defer.promise;
        }

    }
})();